import { type FlowAdvancedFhirBlock, FlowAdvancedFhirBlockSchema } from 'flow-schema';

import { AdvancedFhirFormFields } from './FormFields';
import { ADVANCED_FHIR_DOCUMENTATION_MARKDOWN } from './documentation';
import { type BlockConfigProps } from '../../types';
import { SharedRestNodeOutputContent } from '../Rest/Shared/OutputContent';
import { sharedRestBlockDefaultConfig } from '../Rest/Shared/constants';

export const advancedFhirBlockConfig: BlockConfigProps<FlowAdvancedFhirBlock['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'fhirV2',
  defaultConfig: {
    ...sharedRestBlockDefaultConfig,
    apiInstanceId: '',
    path: '/',
    method: 'GET',
  },
  configFields: {
    schema: FlowAdvancedFhirBlockSchema.shape.config,
    FormFields: AdvancedFhirFormFields,
  },
  OutputContentComponent: SharedRestNodeOutputContent,
  documentationMarkdown: ADVANCED_FHIR_DOCUMENTATION_MARKDOWN,
};
